<template lang='pug' src='./Calendar.pug'></template>

<script>
  import Vue from 'vue'

  import Month from '../Month/Month'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'Calendar',
    components: {
      Month
    },
    data: function () {
      return {
        totalMonths: Vue.config.holidays.TOTAL_MONTHS,
        isHolidaysCalendar: true
      }
    },
    created () {
      this.vacations()
      this.holidays()
      this.cancelHolidays()
      this.cancelHolidays(this.isHolidaysCalendar)
    },
    watch: {
      getSelectedYear: function () {
        this.vacations()
      },
      getUpdateVacations: function (val) {
        this.vacations()
        this.setUpdateVacations(false)
      },
      getUpdateHolidays: function (val) {
        this.holidays()
        this.setUpdateHolidays(false)
      }
    },
    methods: {
      ...mapActions([
        'vacations',
        'holidays',
        'cancelHolidays',
        'setUpdateVacations',
        'setUpdateHolidays'
      ]),
      setMonth (n) {
        const year = this.getSelectedYear
        const everyMonth = new Date(year, n - 1)
        return everyMonth
      }
    },
    computed: {
      ...mapGetters([
        'getHolidays',
        'getVacations',
        'getEditingId',
        'getSelectedYear',
        'getUpdateVacations',
        'getUpdateHolidays'
      ]),
      events () {
        let currentVacations = []
        if (this.getVacations.length) {
          currentVacations = this.getVacations.map(vacations => {
            const HOLIDAY_CLASS = 'holiday'
            return {
              id: vacations.id,
              start: vacations.startDate,
              end: vacations.endDate,
              workingDays: vacations.workingDays,
              cssClass: HOLIDAY_CLASS
            }
          })
        }
        let currentHolidays = []
        if (this.getHolidays.length) {
          currentHolidays = this.getHolidays.map(holidays => {
            const PUBLIC_CLASS = 'public'
            return {
              start: holidays.date,
              end: holidays.date,
              name: holidays.name,
              cssClass: PUBLIC_CLASS
            }
          })
        }
        let allEvents = currentHolidays.concat(currentVacations)
        return allEvents
      }
    }
  }
</script>

<style lang='css' src='./Calendar.css'></style>



// WEBPACK FOOTER //
// Calendar.vue?5c80cbd0